module.exports = __webpack_public_path__ + "static/media/TS.09cca7f8.eot";